import { makeType, initLog } from "../core/base"

import { Stream } from "../core/dispatcher-flyd"

import { modelChanged } from "./common"

import UI from "../core/ui"

// const inContainer1 = function (ele, container) {
//   // console.log(`inContainer called: container`, container.getBoundingClientRect())
//   console.log(`inContainer: container`, container)
//   console.log(`inContainer: element`, ele)
//   const eleTop = ele.offsetTop
//   const eleBottom = eleTop + ele.clientHeight

//   const containerTop = container.scrollTop
//   const containerBottom =
//     containerTop +
//     container.clientHeight +
//     container.getBoundingClientRect().top

//   return eleBottom < containerBottom
// }

const inContainer = function (ele, container) {
  const eleLeft = ele.offsetLeft
  const eleRight = eleLeft + ele.clientWidth

  const containerLeft = container.scrollLeft
  const containerRight =
  containerLeft +
    container.clientWidth +
    container.getBoundingClientRect().left

    return eleRight < containerRight
}


const proto = {
  name: "Carousel",

  initLog,

  init() {
    return {
      scrollLeft: 0,
      offsetLeft: 0,
      first: true,
      last: false,
      reset: false,
      disabled: false,
      initial_position: this.carousel.style.position,
      initial_left: this.carousel.style.left,
    }
  },

  update(msg, model) {
    const children = [...this.carousel.children].filter(
      (n) => n.dataset.role !== "filler"
    )

    // console.log(`update: this.carousel.scrollLeft ${this.carousel.scrollLeft} model.scrollLeft ${model.scrollLeft} this.carousel.offsetLeft ${this.carousel.offsetLeft} model.scrollLeft - this.carousel.offsetLeft ${model.scrollLeft - this.carousel.offsetLeft}`)

    // this.log.warn(`event: ${msg.type}`)

    switch (msg.type) {
      case "click": {
        const { target } = msg
        if (target.hasRole("slideshow-nav-next")) {
          const next = children.filter(
            (n) =>
              n.offsetLeft >
              this.carousel.scrollLeft +
                this.carousel.clientWidth +
                this.carousel.offsetLeft
          )

          if (next.length > 0) {
            model.scrollLeft = next[0].offsetLeft
          }
        }
        if (target.hasRole("slideshow-nav-previous")) {
          // this.log.warn(`1 scrollLeft:`, model.scrollLeft)
          const offset =
            this.carousel.scrollLeft -
            this.carousel.clientWidth +
            this.carousel.offsetLeft
          const last = children.filter((n) => n.offsetLeft <= offset)
          if (last.length > 0) {
            model.scrollLeft = last[last.length - 1].offsetLeft
          } else {
            // TODO: experimental
            model.scrollLeft = children[0].offsetLeft
          }
        }
        break
      }
      case "resize":
        model = this.carouselState(model)
        model.reset = true
        break

      // default:
      //   this.log.warn("unhandled event:", msg.type, msg);
    }

    const prev = children.filter((c) => c.offsetLeft < model.scrollLeft)

    model.first = prev.length < 1

    const next = children.filter(
      (c) => c.offsetLeft > model.scrollLeft + this.carousel.clientWidth
    )

    model.last = next.length < 1
    this.carousel.dataset.scrollLeft = model.scrollLeft
    return model
  },

  view(model) {
    // this.log.warn(`view called:`, { ...model })

    const scrollLeft = model.scrollLeft - this.carousel.offsetLeft
    this.carousel.dataset.scrollLeft = scrollLeft

    const cls = "disabled"
    if (model.reset === true) {
      this.carousel.style.position = model.initial_position
      this.carousel.style.left = model.initial_left

      this.dom
        .findByRole("slideshow-nav-previous")
        .forEach((c) => c.removeClass("invisible"))
      this.dom
        .findByRole("slideshow-nav-next")
        .forEach((c) => c.removeClass("invisible"))
    }

    this.dom.findByRole("slideshow-nav-previous").forEach((c) => {
      if (model.first === true) {
        c.addClass(cls)

        if (model.last === true) {
          c.addClass("invisible")
        }
      } else {
        c.removeClass(cls)
      }
    })

    this.dom.findByRole("slideshow-nav-next").forEach((c) => {
      if (model.last === true) {
        c.addClass(cls)
        if (model.first === true) {
          c.addClass("invisible")
        }
      } else {
        c.removeClass(cls)
      }
    })

    model.offsetLeft = this.carousel.offsetLeft
    this.carousel.scrollLeft = scrollLeft
    this.carousel.dataset.scrollLeft = scrollLeft

    if (model.first === true && model.last === true) {
      this.dom.addClass(`sans_controls`)
      this.dom.addClass("disabled")
      this.dom.dataset.restoreClasses = true
    }

    // necessary?
    if (model.disabled === true) {
      this.dom.addClass("disabled")
      this.dom.dataset.restoreClasses = true
    }

    return model
  },

  carouselState(model) {
    const children = [...this.carousel.children].filter(
      (n) => n.dataset.role !== "filler"
    )

    const notVisible = children.filter(
      (c) => inContainer(c, this.carousel) === false
    )
    if (notVisible.length < 1) {
      model.disabled = true
    }

    const prev = children.filter((c) => c.offsetLeft < model.scrollLeft)

//     const notVisible = children.filter((c) => inContainer(c, this.carousel) === false)
// // console.log(`notVisible: ${notVisible.length} ${notVisible.length < 1}`)
//     if (notVisible.length < 1) {
//       model.disabled = true
//     }
// // console.log(`model:`, model)
//     const prev = children.filter(c => c.offsetLeft < model.scrollLeft)

    model.first = prev.length < 1

    const next = children.filter(
      (c) => c.offsetLeft > model.scrollLeft + this.carousel.clientWidth
    )

    model.last = next.length < 1

    return model
  },

  addFiller() {
    // return // eslint-disable-next-line no-extra-semi

    ;[...Array(10)].map(() => {
      const c = document.createElement("div")
      c.dataset.role = "filler"
      this.carousel.appendChild(c)
    })
  },

  reset() {
    // sending a message to update resets the view
    this.eventStream.stream("reset", {})
  },

  initialize(slideshow) {
    this.dom = slideshow
    this.carousel = this.dom.findByRole("carousel-frame")[0]
    this.initLog()

    const children = [...this.carousel.children].filter(
      (n) => n.dataset.role !== "filler"
    )

    // const notVisible = children.filter((c) => inContainer(c, this.carousel) === false)

    // if (notVisible.length < 1) {
    //   this.carousel.addClass('disabled')
    // }

    // console.log(`notVisible:`, notVisible.length)
    // console.log(`notVisible:`, notVisible)

    // console.log(`carousel frame`, this.carousel)
    this.addFiller()

    let currentModel = this.init()
    // currentModel.initial_position = this.carousel.style.position
    // currentModel.initial_left = this.carousel.style.left

    currentModel = this.carouselState(currentModel)

    this.view(currentModel)

    this.eventStream = new Stream()

    this.eventStream.map((msg) => {
      let model = {
        ...currentModel,
      }
      model = this.update(msg, model)
      // model = this.updateControls(model);
      if (modelChanged(currentModel, model)) {
        model = this.view(model)
      } else if (this.carousel.scrollLeft < currentModel.scrollLeft) {
        // workaround problem: livevieiw rerendered carousel: reset back to initial position
        model = this.view(model)
      }
      // this.log.warn(`model after view:`, {... model})
      currentModel = model
    })

    this.dom.findByRole("slideshow-nav").forEach((c) => {
      if (c.hasRole("slideshow-nav-next")) {
        c.addEvent("click", this.eventStream.stream)
      }
      if (c.hasRole("slideshow-nav-previous")) {
        c.addEvent("click", this.eventStream.stream)
      }
    })

    window.addEvent("resize", this.eventStream.stream)

    this.dom.addEvent("touchstart", this.eventStream.stream)
    this.dom.addEvent("touchmove", this.eventStream.stream)
    this.dom.addEvent("touchend", this.eventStream.stream)

    const carousel = this.carousel
    // this.carousel.addEventListener("scroll", function(){
    //   console.log(`carousel scrolled: scrollLeft ${carousel.scrollLeft}`)
    // });
  },
}

const Carousel = makeType(proto)

export default Carousel

UI.register("carousel", Carousel)
